export default __webpack_public_path__ + "static/media/desensibilisierung_02.8775bc0e.png";